/** UNII channel groups — keep in sync with default_config/channel_configuration/group_channels.json */

export const UNII_CHANNEL_GROUPS = [
  { id: 1, label: 'U-NII-1', band: '5GHz', channels: [36, 40, 44, 48] },
  { id: 2, label: 'U-NII-3', band: '5GHz', channels: [149, 153, 157, 161, 165] },
  { id: 3, label: 'U-NII-5', band: '6GHz', channels: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93] },
  { id: 4, label: 'U-NII-6', band: '6GHz', channels: [97, 101, 105, 109, 113] },
  { id: 5, label: 'U-NII-7', band: '6GHz', channels: [117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185] },
  { id: 6, label: 'U-NII-8', band: '6GHz', channels: [189, 193, 197, 201, 205, 209, 213, 217, 221] },
];

export const UNII_BY_ID = UNII_CHANNEL_GROUPS.reduce((acc, g) => {
  acc[g.id] = g;
  return acc;
}, {});

/** Default backhaul DSATUR allow-list (matches backend DefaultOptimizeChannelGroupIDs). */
export const DEFAULT_OPTIMIZE_CHANNEL_GROUP_IDS = [3, 5];

export function defaultOptimizeChannelGroupSummary() {
  return DEFAULT_OPTIMIZE_CHANNEL_GROUP_IDS
    .map((id) => UNII_BY_ID[id]?.label || id)
    .join(' + ');
}

export function formatUniiOption(group) {
  const chMin = group.channels[0];
  const chMax = group.channels[group.channels.length - 1];
  const bandLabel = group.band === '5GHz' ? '5 GHz' : '6 GHz';
  return `${group.id} — ${group.label} (${bandLabel}, ch ${chMin} – ${chMax})`;
}

export function summarizeUniiSelection(ids) {
  if (!Array.isArray(ids) || ids.length === 0) return '';
  const buckets = { '5GHz': [], '6GHz': [] };
  ids.forEach((id) => {
    const g = UNII_BY_ID[id];
    if (g) {
      buckets[g.band].push(`${g.channels[0]} – ${g.channels[g.channels.length - 1]}`);
    }
  });
  const parts = [];
  if (buckets['5GHz'].length) parts.push(`5 GHz: ch ${buckets['5GHz'].join(', ')}`);
  if (buckets['6GHz'].length) parts.push(`6 GHz: ch ${buckets['6GHz'].join(', ')}`);
  return parts.length ? parts.join('; ') : '';
}
